import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { corporateClientCredential } from '../../store/actions/corporateAction';
import { getContentKeyAccToLang } from '../../utils/utils';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { TextWeight, isArabic } = dynamicfunction();

  const { authLoading } = useSelector((state) => state.auth);
  const { authContent } = useSelector((state) => state.content);

  const location = useLocation();
  const { clientId } = location.state ?? {};

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_corporate_client_credential?.data?.attributes, key, isArabic);
  };

  const onsubmit = (values) => {
    const api_data = {
      clientId: clientId,
      username: values?.username,
      password: values?.password,
      confirmPassword: values?.confirmPassword,
    };
    dispatch(corporateClientCredential(api_data, navigate));
  };

  return {
    TextWeight,
    authLoading,
    onsubmit,
    getContentKey,
  };
};
